

































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { IdentitasPasien } from "@/types";
import { storeDokter } from "@/store/modules/dokter";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import { storeHasilPemeriksaanDarah } from "@/store/modules/HasilPemeriksaanDarahStore";
import { getAge, formatDMYDate } from "@/utility/DateUtils";
import SvcPersetujuanTransfusiInkompatibel from "@/services/PersetujuanTransfusiInkompatibel";
import StorePersetujuanTransfusiInkompatibel from "@/store/modules/PersetujuanTransfusiInkompatibel";
import SvcPermintaanKomponenDarah from "@/services/PermintaanKomponenDarah";
import { prefillRuangRawat } from "@/utils/prefillBangsalKelas";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import { JENIS_KELAMIN_OPTIONS, normalisasiJk } from "@/utils/jenisKelamin";
import {
  opsiSumberInkompatibel,
  crossmatchDariSumber,
  jejakSumber,
  SumberInkompatibel
} from "@/utils/prefillInkompatibel";
import moment from "moment";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { localISODate, parseLocalDate } from "@/utils/localDate";
import { opsiBagianPenyakit } from "./persetujuanLayananDarah";

@Component({
  components: { VCDateTimePicker, UnitRuangPicker },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class PersetujuanTransfusiInkompatibelInputCard extends Vue {
  get opsiBagian(): string[] {
    return opsiBagianPenyakit(this.bagian);
  }

  @Prop() readonly register!: string;
  @Prop() dataSuket!: any;

  @Prop({ type: Number, default: null }) readonly prefillHasilId!: number | null;

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  valid = false;
  saving = false;

  requiredRule = [v => !!v || "*Kolom ini harus diisi"];
  hariIni = moment()
    .endOf("day")
    .toDate();

  jenisKelaminOptions = JENIS_KELAMIN_OPTIONS;
  golonganDarahOptions = ["A", "B", "O", "AB"];

  hubunganOptions = [
    { value: "diri_sendiri", text: "Diri Sendiri" },
    { value: "istri", text: "Isteri" },
    { value: "suami", text: "Suami" },
    { value: "anak", text: "Anak" },
    { value: "ibu", text: "Ibu" },
    { value: "ayah", text: "Ayah" },
    { value: "lainnya", text: "Lainnya" }
  ];

  is_diri_sendiri = this.dataSuket?.content?.is_diri_sendiri ?? true;

  pembuat = {
    nama:
      this.dataSuket?.content?.pembuat_pernyataan?.nama ||
      (this.is_diri_sendiri ? this.pasien.nama : ""),
    umur:
      this.dataSuket?.content?.pembuat_pernyataan?.umur ||
      (this.is_diri_sendiri ? this.pasienUmur : ""),
    jenis_kelamin:
      normalisasiJk(
        this.dataSuket?.content?.pembuat_pernyataan?.jenis_kelamin
      ) || (this.is_diri_sendiri ? normalisasiJk(this.pasien.jk) : "") || "",
    nik:
      this.dataSuket?.content?.pembuat_pernyataan?.nik ||
      (this.is_diri_sendiri ? this.pasien.nik || "" : ""),
    alamat:
      this.dataSuket?.content?.pembuat_pernyataan?.alamat ||
      (this.is_diri_sendiri ? this.pasien.alamat : ""),
    telepon:
      this.dataSuket?.content?.pembuat_pernyataan?.telepon ||
      (this.is_diri_sendiri ? this.pasien.telp || "" : ""),
    hubungan:
      this.dataSuket?.content?.pembuat_pernyataan?.hubungan ||
      (this.is_diri_sendiri ? "diri_sendiri" : ""),
    hubungan_lain:
      this.dataSuket?.content?.pembuat_pernyataan?.hubungan_lain || ""
  };

  komponen_darah = this.dataSuket?.content?.komponen_darah || "";

  crossmatch = {
    mayor: this.dataSuket?.content?.crossmatch?.mayor || "",
    minor: this.dataSuket?.content?.crossmatch?.minor || "",
    auto_control: this.dataSuket?.content?.crossmatch?.auto_control || "",
    dct: this.dataSuket?.content?.crossmatch?.dct || "",
    ict: this.dataSuket?.content?.crossmatch?.ict || ""
  };

  golongan_darah = this.dataSuket?.content?.golongan_darah || "";
  bagian = this.dataSuket?.content?.bagian || "";
  bangsal = this.dataSuket?.content?.bangsal || "";
  saksi_1 = this.dataSuket?.content?.saksi_1 || "";
  saksi_2 = this.dataSuket?.content?.saksi_2 || "";

  sumber_hasil: any = this.dataSuket?.content?.sumber_hasil || null;

  sumberValue: string | null = null;

  tanggal_persetujuan = this.dataSuket?.content?.tanggal_persetujuan
    ? moment(this.dataSuket.content.tanggal_persetujuan).toDate()
    : new Date();
  signee_user_id = this.dataSuket?.signee_user_id || this.user.id;
  creator_user_id = this.dataSuket?.creator_user_id || this.user.id;
  surat_date = this.dataSuket?.surat_date || moment().format("YYYY-MM-DD");

  get suratDate(): Date | null {
    return parseLocalDate(this.surat_date);
  }

  set suratDate(val: Date | null) {
    this.surat_date = val ? localISODate(val) : "";
  }

  get pasien(): Partial<IdentitasPasien> {
    return storePasien.identitasPasien || {};
  }

  get pasienUmur() {
    return this.pasien.tgl_lahir ? getAge(formatDMYDate(this.pasien.tgl_lahir)) : "";
  }

  get user() {
    return userModule.user;
  }

  get listDokter() {
    return storeDokter.list;
  }

  get hasilItems() {
    return storeHasilPemeriksaanDarah.items || [];
  }

  get opsiSumber(): SumberInkompatibel[] {
    return opsiSumberInkompatibel(this.hasilItems as any, this.waktuSingkat);
  }

  get adaIsiCrossmatch(): boolean {
    const c = this.crossmatch;

    return !!(c.mayor || c.minor || c.auto_control || c.dct || c.ict);
  }

  get bangsalDariJurnal(): string {
    return prefillRuangRawat(RegisterKunjungan.register, this.register);
  }

  waktuSingkat(v: string | null): string {
    return v ? moment(v).format("DD-MM-YYYY HH:mm") : "";
  }

  labelReaksi(v: string | null): string {
    if (!v) return "";

    const peta = (storeHasilPemeriksaanDarah.katalog as any).label_reaksi || {};

    return peta[v] || String(v);
  }

  async mounted() {
    if (this.dataSuket) return;

    if (this.is_diri_sendiri && !this.pembuat.jenis_kelamin) {
      this.pembuat.jenis_kelamin = normalisasiJk(this.pasien.jk) || "";
    }

    await storeHasilPemeriksaanDarah.loadKatalog();

    if (!this.bangsal) this.bangsal = this.bangsalDariJurnal;

    this.pilihSumberAwal();
  }

  pilihSumberAwal() {
    const opsi = this.opsiSumber;
    if (!opsi.length) return;

    if (this.prefillHasilId) {
      const cocok = opsi.find(
        o => String(o.hasil.id) === String(this.prefillHasilId)
      );

      if (cocok) {
        this.sumberValue = cocok.value;

        return;
      }
    }

    if (opsi.length === 1) this.sumberValue = opsi[0].value;
  }

  @Watch("sumberValue")
  onSumberChange(val: string | null) {
    if (val) this.terapkanSumber(true);
  }

  terapkanSumber(paksa = false) {
    const s = this.opsiSumber.find(o => o.value === this.sumberValue);
    if (!s) return;

    const cm = crossmatchDariSumber(s, this.labelReaksi);
    if (paksa || !this.adaIsiCrossmatch) this.crossmatch = { ...cm };

    if (paksa || !this.golongan_darah) {
      this.golongan_darah = s.hasil.gol_darah || this.golongan_darah;
    }

    if (!this.bangsal) {
      this.bangsal = this.bangsalDariJurnal || s.hasil.bangsal;
    }

    this.sumber_hasil = jejakSumber(s);

    this.prefillKomponenDarah(s.hasil.permintaan_komponen_darah_id);
  }

  async prefillKomponenDarah(permintaanId: number | null) {
    if (!permintaanId || this.komponen_darah) return;

    try {
      const resp: any = await SvcPermintaanKomponenDarah.find(permintaanId);
      const items = resp?.data?.items || [];

      const teks = items
        .map(i => (i.unit_kolf ? `${i.label_macam} ${i.unit_kolf} kolf` : i.label_macam))
        .filter(v => !!v)
        .join(", ");

      if (teks && !this.komponen_darah) this.komponen_darah = teks;
    } catch {
      return;
    }
  }

  get input() {
    return {
      register_id: this.dataSuket?.register_id || this.register,
      pasien_rm: this.dataSuket?.pasien_rm || this.pasien.rm,
      unit_id: this.dataSuket?.unit_id || this.user.unit_id,
      content: {
        is_diri_sendiri: this.is_diri_sendiri,
        pembuat_pernyataan: {
          nama: this.pembuat.nama,
          umur: this.pembuat.umur,
          jenis_kelamin: this.pembuat.jenis_kelamin,
          nik: this.pembuat.nik,
          alamat: this.pembuat.alamat,
          telepon: this.pembuat.telepon,
          hubungan: this.pembuat.hubungan,
          hubungan_lain:
            this.pembuat.hubungan === "lainnya"
              ? this.pembuat.hubungan_lain
              : ""
        },
        komponen_darah: this.komponen_darah,
        crossmatch: {
          mayor: this.crossmatch.mayor,
          minor: this.crossmatch.minor,
          auto_control: this.crossmatch.auto_control,
          dct: this.crossmatch.dct,
          ict: this.crossmatch.ict
        },
        golongan_darah: this.golongan_darah,
        bagian: this.bagian,
        bangsal: this.bangsal,
        saksi_1: this.saksi_1,
        saksi_2: this.saksi_2,
        tanggal_persetujuan: this.tanggal_persetujuan
          ? moment(this.tanggal_persetujuan).format("YYYY-MM-DD HH:mm:ss")
          : null,
        sumber_hasil: this.sumber_hasil
      },
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id
    };
  }

  onDiriSendiriChange(val: boolean) {
    if (val) {
      this.pembuat.nama = this.pasien.nama;
      this.pembuat.umur = this.pasienUmur;
      this.pembuat.jenis_kelamin = normalisasiJk(this.pasien.jk) || "";
      this.pembuat.nik = this.pasien.nik || "";
      this.pembuat.alamat = this.pasien.alamat;
      this.pembuat.telepon = this.pasien.telp || "";
      this.pembuat.hubungan = "diri_sendiri";
      this.pembuat.hubungan_lain = "";
    } else {
      this.pembuat.nama = "";
      this.pembuat.umur = "";
      this.pembuat.jenis_kelamin = "";
      this.pembuat.nik = "";
      this.pembuat.alamat = "";
      this.pembuat.telepon = "";
      this.pembuat.hubungan = "";
      this.pembuat.hubungan_lain = "";
    }
  }

  save() {
    if (this.readOnly) return;

    if (!this.saving) {
      this.saving = true;

      const action = this.dataSuket
        ? SvcPersetujuanTransfusiInkompatibel.update(
            this.dataSuket.id,
            this.input
          )
        : SvcPersetujuanTransfusiInkompatibel.create(this.input);

      action
        .then(() => {
          appModule.NoticeDelay(
            "Berhasil Simpan Persetujuan Transfusi Darah Inkompatibel"
          );
          this.close();
          StorePersetujuanTransfusiInkompatibel.getSuketByRegister(
            this.register
          );
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  close() {
    this.$emit("close");
  }
}
